// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3m3L0A"};